import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.2646 3L12.9039 4.36062L13.9582 5.41491L7.99332 10.1996L6.56692 8.77323L5.20631 10.1338L8.86344 13.791L3 19.6525V21H4.34746L10.209 15.1366L13.8662 18.7937L15.2268 17.4331L13.8831 16.0894L18.602 10.0587L19.6394 11.0961L21 9.73544L14.2646 3Z",
		fill: "currentColor"
	})
});
export default SvgPin;
